import { ICustomerSettings } from './ICustomerSettings';
import settings from './alipi-settings';
export default settings as ICustomerSettings;